import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import Accordion from '../ui/Accordion.jsx';
import TimerButton from '../ui/TimerButton.jsx';
import Button from '../ui/Button.jsx';

const Text = ({ heading_img, heading, subheading, text, button, fn }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);
  const [accordionLocked, setAccordionLocked] = useState(false);
  const [counter, setCounter] = useState(null); // null = timer neběží

  // Odpočet
  useEffect(() => {
    if (counter === null || accordionLocked) return;

    if (counter <= 0) {
      setAccordionOpen(false);
      setAccordionLocked(true);
      return;
    }

    const interval = setInterval(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, accordionLocked]);

  // Otevření accordionu
  const handleAccordionToggle = () => {
    if (accordionLocked) return;

    const newOpen = !accordionOpen;
    setAccordionOpen(newOpen);

    if (newOpen && counter === null) {
      setCounter(60*4); // zde se nastavuje čas
    }
  };

  return (
    <div className="component-email">
      <div className="row justify-center">
        <HeadingOne className="col xl:w-10/12" image={heading_img} heading={heading} />
      </div>
      <div className="row justify-center">
        <div className="col xl:w-10/12">
          <Card>
            <CardHeader
              heading={subheading}
              button={<TimerButton time={counter} />}
            />
            <CardBody>
              <div className="row items-center justify-center">
                <div className="col text-xl">
                        <div dangerouslySetInnerHTML={{ __html: text }}></div>
                </div>
                <div className="col text-xl">
                  <Accordion
                    isOpen={accordionOpen}
                    onToggle={handleAccordionToggle}
                    locked={accordionLocked}
                  />
                  {button && (
                    <div className="mt-12 flex justify-end">
                      <Button {...button} onClick={() => fn.handleAction(button.action)} />
                    </div>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Text;
